function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@font-face{font-family:&quot;Virgil&quot;;src:url(https://excalidraw.com/FG_Virgil.woff2)}@font-face{font-family:&quot;Cascadia&quot;;src:url(https://excalidraw.com/Cascadia.woff2)}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e64980",
  strokeWidth: 0,
  d: "M39.446 6.148l145.845 2.385 17.665 6.365 4.182 8.648 6.307 12.444-3.256 58.99-2.367 19.73-3.433 6.812-17.416 4.875-146.57 1.152-17.909-6.85-4.596-8.504-4.103-10.34.523-69.524.256-12.892 2.942-6.304 20.161-1.288"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M39.033 12.671c40.088-6.191 81.885-3.684 147.48.756M41.13 10.979c42.925-.502 82.398.73 140.789-.946M183.75 10c22.717 2.95 25.511 6.435 26.998 29.32M186.87 12.6c18.796-.651 26.348 5.245 23.405 27.199m-.653-1.225c-1.555 17.006 3.4 28.755-.596 60.974m5.833-59.864c-2.898 12.316-.14 26.21-3.61 60.006M213 97.75c1.775 22.404-10.054 28.2-29.075 29.871m27.885-27.298c-1.434 19.803-4.541 22.661-24.223 29.322m-4.99-3.213c-27.595.872-59.903 2.39-141.76 3.053m144.882-3.002c-38.948-1.207-74.063-.19-147.523.149m1.054.368c-19.082-.932-32.649-9.595-30.808-27.49m28.805 27.317c-16.568 2.584-28.143-12.303-24.133-29.245m-1.418.82c-1.08-24.871 2.042-43.477-4.608-59.91m3.528 57.913c.684-16.26-2.116-31.34.597-55.316M10 39.25c2.113-18.669 10.726-26.09 28.734-32.843M10.712 38.94C5.934 17.16 23.768 5.91 35.576 12.225"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e64980",
  strokeWidth: 0,
  d: "M435.665 13.9l144.195-3.702 22.599 6.173 4.616 5.403 7.279 13.96-.346 65.589-3.496 15.986-9.717 9.315-20.85 5.964-141.783.681-21.91-9.772-4.533-7.761-1-9.057-3.996-72.317 4.073-10.123 5.92-6.323 24.24-6.69"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M440.09000000000003 10.225999999999999c41.59 4.918 80.152.955 144.58 4.108m-144.928-1.15c53.345-1.581 105.084-.013 141.39-.44m1.118.756c16.572 2.996 29.664 7.375 32.844 33.118m-35.167-32.51c24.28 3.742 27.858 5.741 36.036 29.527m-6.713-4.856c-1.7 18.34-.42 32.28.975 61.739m2.442-59.297c.148 24.474.116 48.67-.128 61.177m-1.039-1.148c1.826 16.044-12.044 30.216-28.814 30.034m26.439-29.75c-1.114 14.663-11.907 27.888-24.18 29.493m-6.55 2.91c-26.362-4.675-56.946-6.695-140.58-3.08m144.563.327c-31.886-.068-64.665-1.786-146.55-2.166m1.922 1.482c-20.646 2.78-29.31-9.665-27.258-27.312m24.05 24.281c-18.134 3.248-25.976-4.853-30.168-30.79m4.434 6.098c3.975-18.828-.823-26.336 1.006-59.937m-1.478 57.716c.616-18.748-1.345-36.182 1.326-58.421m-1.162.615c2.42-22.672 12.6-29.114 31.31-29.826m-33.928 30.673c3.279-18.652 8.2-30.093 36.193-28.158"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#e64980",
  strokeWidth: 0,
  d: "M442.337 251.144l150.334 1.19 18.356 3.293 7.113 11.283.27 9.624 1.275 60.8-.977 17.506-12.146 13.141-12.444-2.41-145.372 3.343-23.196-6.85-4.33-1.109-3.494-12.713 3.014-77.578-3.084-9.294 8.813-8.466 17.03-5.375"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M445.01800000000003 254.98999999999998c39.919-2.566 73.552-5.626 145.555-2.908m-143.675-.364c43.525-.806 85.687-2.866 143.835-1.406m-.483 1.188c19.958-3.034 25.291 5.809 29.535 31.593m-30.473-34.813c16.006 7.172 31.916 11.544 30.07 32.473m.476-2.977c-3.377 24.738-1.055 47.154 1.342 62.19m-3.182-58.22c1.655 17.963 2.076 38.038 1.524 55.9m-.042 1.604c-3.976 17.898-9.562 29.308-32.28 25.662m33.902-28.12c-1.268 23.715-6.922 27.86-32.5 30.516m1.718 1.66c-39.649 2.234-80.41-.907-143.43-2.883m142.725 3.445c-33.042 1.86-67.709 2.074-143.817-2.34m-.068 1.31c-17.814.575-27.776-13.374-28.403-25.49m28.406 24.296c-21.137-3.04-30.46-12.86-30.498-23.777m1.131-3.997c-3.357-10.975 3.24-28.842-3.35-59.031m3.023 60.686c-.688-16.278-1.45-29.044.36-59.919m.081-.518c-2.776-18.424 6.458-27.188 26.918-25.751m-27.87 23.842c1.946-20.739 12.636-29.069 26.485-25.89M213.213 69.86c31.382-.957 160.332-3.195 192.863-3.96M217.44 67.873c30.763.699 154.698 1.495 186.44 1.494"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M376.918 79.626c9.392-.376 19.765-7.028 30.43-13.422m-33.24 12.446c12.528-2.347 17.896-6.374 29.775-7.967"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M376.999 59.105c9.75 7.822 20.09 9.37 30.349 7.099m-33.16-8.075c12.11 4.192 17.453 6.701 29.695 12.554"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeDasharray: "12 8",
  strokeWidth: 2.5,
  d: "M137.379 135.695c45.674 22.435 227.975 113.348 273.326 136.57"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2.5,
  d: "M379.32 271.17c7.235-.617 17.436-2.293 28.97.332M388.559 252.847c5.408 3.106 13.67 5.273 19.731 18.655"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M531.124 236.465c-.51-16.04-3.077-77.703-3.015-93.191m7.79 90.432c-.928-15.67-9.853-78.94-10.692-94.752"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M537.519 164.206c-1.486-2.636-4.696-10.696-13.126-23.861m12.784 23.647c-3.267-5.297-6.498-14.342-13.325-26.367"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M517.104 166.295c4.074-3.096 6.461-11.729 7.29-25.95m-7.632 25.736c3.073-6.3 6.205-15.994 7.09-28.456"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M512.565 166.746c5.035-.263 22.327-1.473 26.459-1.657m-28.512.68c4.863.077 22.715-4.305 26.83-5.1"
}));

function SvgDependencyInversion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 669 378.5"
  }, props), _ref, _ref2, _ref3, /*#__PURE__*/React.createElement("text", {
    y: 19,
    fill: "#fff",
    fontFamily: "Cascadia, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(37 54.5)",
    style: {
      whiteSpace: "pre"
    }
  }, "SignupService"), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fontFamily: "Cascadia, Segoe UI Emoji",
    fontSize: 20,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 64.5,
    y: 19,
    style: {
      whiteSpace: "pre"
    },
    transform: "translate(448 47.5)"
  }, "(interface)"), /*#__PURE__*/React.createElement("text", {
    x: 64.5,
    y: 43,
    style: {
      whiteSpace: "pre"
    },
    transform: "translate(448 47.5)"
  }, "ApiClient")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 19,
    fill: "#fff",
    fontFamily: "Cascadia, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(455 300.5)",
    style: {
      whiteSpace: "pre"
    }
  }, "HttpClient")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 23,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(566 172.5)",
    style: {
      whiteSpace: "pre"
    }
  }, "Implement")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 23,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(274 17.5)",
    style: {
      whiteSpace: "pre"
    }
  }, "Import")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 23,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(182 212.5)",
    style: {
      whiteSpace: "pre"
    }
  }, "Execute")), _ref13);
}

export default __webpack_public_path__ + "static/dependency-inversion.7625394a.svg";
export { SvgDependencyInversion as ReactComponent };